import React from 'react'
import {Offcanvas} from 'react-bootstrap'
import {useAiCoach} from '../core/AiCoachContext'
import ChatPanel from './ChatPanel'

/**
 * Single source-of-truth Offcanvas for the AI Coach. Rendered once at
 * the layout level. The header launcher, FAB and contextual buttons
 * just call `openCoach()` from the context.
 */
export const AiCoachDrawer: React.FC = () => {
  const {open, initialPrompt, openVersion, closeCoach, consumeInitialPrompt} = useAiCoach()

  return (
    <Offcanvas
      show={open}
      onHide={closeCoach}
      placement='end'
      backdrop
      scroll={false}
      style={{width: 'min(460px, 100vw)'}}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{fontSize: 16, fontWeight: 600}}>
          <i className='bi bi-stars me-2' style={{color: 'rgba(232, 64, 64, 0.95)'}} />
          AI Coach
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body style={{padding: 12, display: 'flex', flexDirection: 'column'}}>
        <ChatPanel
          compact
          height='100%'
          initialPrompt={initialPrompt}
          initialPromptKey={openVersion}
          onInitialPromptConsumed={consumeInitialPrompt}
        />
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default AiCoachDrawer
